<template>
  <div id="app" class="app">
      <div class="admin-head flex flex-mid flex-center-3" v-if="getView || isShowView" >
        <img class="admin-logo" src="./assets/logo.png" alt="">
        <div class="admin-user flex flex-mid flex-center-3">
            <div class="admin-user-box flex flex-mid" @click.stop="showUserEdit">
                <div class="admin-user-img">
                    <img class="block w100" :src="usericon" alt="">
                </div>
                <div class="admin-user-info">
                    <span>{{username}}</span>
                    <i>：{{userbelong}}</i>
                    <i class="iconfont icon-zheng-triangle" :class="{'admin-user-edit-icon':isUserEditIcon}"></i>
                </div>
                <div class="admin-user-edit" :class="{'admin-user-edit-show':isUserEditIcon}">
                    <ul @click.stop>
                        <li><a href="javascript:" @click.stop="bindRePass">修改密码</a></li>
                    </ul>
                </div>
            </div>
            <div class="admin-user-logout">
                <a href="javascript:" @click="bindLogout">
                    <img src="./components/main/images/logout.png" alt="">
                    <span>退出</span>
                </a>
            </div>
        </div>
    </div>
    <div class="admin-main">
        <div class="admin-main-left" v-if="getView || isShowView">
            <main-nav :list="navs"></main-nav>
        </div>
        <div class="admin-main-right">
            <div class="admin-main-right-title flex flex-mid" v-if="getView || isShowView">
                <h2 :class="{'color9':h2}">{{h1}}</h2>
                <i v-if="h2" class="iconfont icon-xiangyou"></i>
                <h2 v-if="h2">{{h2}}</h2>
            </div>
            <div class="admin-main-right-box">
                <transition :name="transitionName">
                  <router-view/>    
                </transition>
            </div>
        </div>
    </div>
    <div class="admin-hint" v-show="isShowRe" @click="hideHint">
        <div class="admin-hint-main" @click.stop>
            <p class="admin-hint-title">修改密码</p>
            <div class="admin-hint-box">
                <p><i>*</i><span>原密码</span></p>
                <input type="password" v-model="initPass" placeholder="请输入密码">
            </div>
            <div class="admin-hint-box">
                <p><i></i><span>新密码</span></p>
                <input type="password" v-model="newPass" placeholder="请输入新密码">
            </div>
            <div class="admin-hint-box">
                <p><i></i><span>确认密码</span></p>
                <input type="password" v-model="rePass" placeholder="请再次输入新密码">
            </div>
            <a class="admin-hint-submit" href="javascript:" @click="bindRePassSubmit">提交</a>
        </div>
    </div>
    <hint></hint>
  </div>
</template>

<script>
import Hint from "@/components/hint"
import mainNav from "@/components/main/mainNav"
import {mapGetters , mapActions} from "vuex"

export default {
    name: 'app',
    data(){
        return {
        transitionName:'slide-left',
        // user
        isUserEditIcon:"",
        usericon:"",
        username:"",
        userbelong:"",
        // 路由
        navs:[
            {name:"推广统计分析",icon:"icon-tongji",child:[{name:"活跃资源统计",url:"/app/main/livelyResource"},{name:"事件分析",url:"/app/main/affairAnalyze"},{name:"事件管理",url:"/app/main/affairChange"}]}, //,{name:"事件总览",url:"/app/main/affairPandect"}
            {name:"推广渠道管理",icon:"icon-tuiguangqudao",child:[{name:"渠道组管理",url:"/app/main/ditchsbox"},{name:"渠道媒介管理",url:"/app/main/ditchMediumBox"},{name:"推广资源管理",url:"/app/main/popularizeBox"}]},
            // {name:"进程管理",icon:"icon-qiehuan1",url:"/app/main/courseChange"},
            // {name:"用户管理",icon:"icon-users-1",child:[{name:"用户管理",url:"/app/main/userControl"}]},
        ],
        isShow:false,
        isShowRe:false,
        h1:"",
        h2:"",
        //修改密码
        initPass:"",
        newPass:"",
        rePass:"",
        // 显示页面
        isShowView:false,
        //权限
        jurisdiction:""   
        }
    },
    watch:{
        '$route'(to,from){
            const toDepth = to.meta.index
            const fromDepth = from.meta.index
            this.transitionName = toDepth < fromDepth ? 'slide-right':'slide-left';
        },
        'getUser':function(val){
            var db =   JSON.parse(localStorage.getItem("jurisdiction")).user_belong;
            this.username = val.username;
            this.userbelong = db[val.user_belong] || db[val.belong];
            this.usericon = val.avatar == "0" || val.avatar == ""?'/static/user.jpeg':val.avatar;
        },
        'getTitle':function(val){
            this.h1 = this.navs[val.a].name;
            this.h2 = this.navs[val.a].child ?this.navs[val.a].child[val.b].name :"";
        },
        'getSuper':function(val){
            if(val){
                this.navs[0].child[3] = {name:"事件总览",url:"/app/main/affairPandect"};
                this.navs[2] = {name:"进程管理",icon:"icon-qiehuan1",url:"/app/main/courseChange"};
                this.navs[3] = {name:"用户管理",icon:"icon-users-1",child:[{name:"用户管理",url:"/app/main/userControl"}]};
            }else{
                this.navs.splice(2)
                this.navs[0].child.splice(3)
            }
        }
    },
    computed:{
        ...mapGetters(['getView','getUser','getTitle','getSuper'])
    },
    mounted(){
        //   存贮 用户权限 性别
        if(!localStorage.getItem("jurisdiction")){
            $.ajax({
                url:webUrl+"/user/getEditInfo",
                headers: {
                    'Auth-Token' : localStorage.getItem("token")
                },
                type:"POST",
                success:(res)=>{
                    localStorage.setItem("jurisdiction",JSON.stringify(res.data))
                }
            })
        }
        // 标题
        let title = JSON.parse(sessionStorage.getItem("nav"));
        this.h1 = this.navs[title.a].name;
        this.h2 = this.navs[title.a].child ?this.navs[title.a].child[title.b].name :"";
        $("body").on("click",()=>{
            this.isUserEditIcon = false;
        })
        this.isShowView = JSON.parse(localStorage.getItem("setView"));
        let user = JSON.parse(localStorage.getItem("get"))
        if(user){
            this.username = user.username || "";
            this.usericon = (user.avatar != 0 && user.avatar != "")?user.avatar:'/static/user.jpeg';
            this.userbelong = JSON.parse(localStorage.getItem("jurisdiction")).user_belong[user.belong];
        }

        // 判断是不是super local("sb")
        if(localStorage.getItem("sb") && localStorage.getItem("sb") == 1){
            this.navs[0].child[3] = {name:"事件总览",url:"/app/main/affairPandect"};
            this.navs[2] = {name:"进程管理",icon:"icon-qiehuan1",url:"/app/main/courseChange"};
            this.navs[3] = {name:"用户管理",icon:"icon-users-1",child:[{name:"用户管理",url:"/app/main/userControl"}]}
        }else{
            try {
                this.navs.splice(2)
                this.navs[0].child.splice(3)
            } catch (error) {
                
            }
        }
    },
    methods:{
        ...mapActions(['setView','setHint','setSuper','setUser']),
        showUserEdit(){
            this.isUserEditIcon = !this.isUserEditIcon
        },
        bindRePass(){
            this.isShowRe = true
        },
        hideHint(){
            this.isShowRe =  this.isUserEditIcon = false;
            this.initPass = this.newPass = this.rePass = "";
        },
        bindLogout(){
            $.ajax({
                url:webUrl+"/auth/logout",
                headers: {
                    'Auth-Token' : localStorage.getItem("token")
                },
                type:"POST",
                data:{auth_token:localStorage.getItem("token")},
                dataType:"JSON",
                success:(res)=>{
                    localStorage.removeItem("sb")
                    localStorage.removeItem("token")
                    localStorage.removeItem("xxx")
                    localStorage.removeItem("time")
                    localStorage.removeItem("get")
                    sessionStorage.setItem('nav',`{"a":0,"b":0}`)
                    this.isShowView = false;
                    localStorage.setItem("setView",false);
                    // 权限列表
                    this.setView(false)
                    this.setSuper(false)
                    this.setUser("")
                    this.navs.splice(2)
                    this.navs[0].child.splice(3)
                    // 
                    this.$router.push({path:"/"})
                    window.location.href = "/"
                    this.setHint({txt:"退出成功",className:"hint-success"})
                }
            })
        },
        bindRePassSubmit(){
            if(!this.initPass){
                this.setHint({txt:"请输入密码",className:"hint-error"})
                return ;
            }else if(!this.newPass){
                this.setHint({txt:"请输入新密码",className:"hint-error"})
                return ;
            }else if(!this.rePass){
                this.setHint({txt:"请再次输入新密码",className:"hint-error"})
                return ;
            }
            $.ajax({
                url:webUrl+"/auth/change",
                headers: {
                    'Auth-Token' : localStorage.getItem("token")
                },
                type:"POST",
                data:{
                    auth_token:localStorage.getItem("token"),
                    password:this.initPass,
                    new_password:this.newPass,
                    re_password:this.rePass
                },
                dataType:"JSON",
                success:(res)=>{
                    if(res.status==1){
                        localStorage.removeItem("token")
                        localStorage.removeItem("xxx")
                        localStorage.removeItem("time")
                        this.$router.push({path:"/"})
                        this.isShowRe = this.isUserEditIcon = false;
                        this.setHint({txt:"密码修改成功",className:"hint-success"})
                    }else{
                        this.setHint({txt:res.msg,className:"hint-success"})
                    }
                }
            });
        }
    },
    components:{
        Hint:Hint,
        mainNav:mainNav
    }
}
</script>

<style>
@import "./assets/global.css";
@import "./assets/icon/iconfont.css";
@import "./App.css";
</style>



// WEBPACK FOOTER //
// src/App.vue